import I18n from 'app/i18n';
import {translatedName} from 'app/utils/translations_helper';
import {stringTypeOfBonus} from 'app/utils/stringTypeOfBonus';
import {lootboxPrizeType} from 'app/utils/lootboxPrizeType';
import {fixed2int} from 'app/utils/fixed';
import {formatLootboxMoney} from 'app/utils/lootboxRarity';
import LootInterface from 'app/interfaces/LootInterface';

const frozenBalanceTitle = (loot: LootInterface): string => `${fixed2int(loot.frozen_money_amount || 0)} ${I18n.t('frozen_balance')}`;

export const lootboxPrizeTitle = (loot: LootInterface): string => {
    switch (lootboxPrizeType(loot)) {
    case 'points':
        return `${loot.points_amount} ${I18n.t('points', {count: loot.points_amount})}`;
    case 'money':
        return formatLootboxMoney(loot.money_amount);
    case 'frozen_money':
        return I18n.t('frozen_balance');
    case 'bonus':
        return `${formatLootboxMoney(loot.bonus_amount)} ${stringTypeOfBonus(Boolean(loot.bonus))}`;
    case 'recipe':
        return translatedName(loot.recipe);
    case 'steam_skin':
        return translatedName(loot.steam_skin);
    default:
        return loot.title || '';
    }
};

export const lootboxPrizeWinName = (loot: LootInterface): string => {
    if (lootboxPrizeType(loot) === 'frozen_money') {
        return frozenBalanceTitle(loot);
    }

    return lootboxPrizeTitle(loot);
};
